import React, { useState, useEffect, useRef } from 'react';
import Header from '../home/components/Header.tsx';
import MacroEnv from './components/MacroEnv.tsx';
import ClientNeeds from './components/ClientNeeds.tsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { EXTERNAL_USER_ID } from '@/config/env';
import { qryCopilotValueApi, getCopilotValueByTaskIdApi } from '@/api/copilot';
import { toast } from 'sonner';
import { AssetAllocation, ProductCard } from './components';
import { ScrollArea } from '@/components/ui/scroll-area';
import { usePollingApi } from '@/hooks/usePollingApi';
// 修复：用 forwardRef 包裹，明确 props 和 ref 类型（避免 any）
const DiagnosisPage = React.forwardRef<any | null, {}>((_, ref) => {
  const [currentTaskId, setCurrentTaskId] = useState<string>('');
  const [generatePlanLoading, setGeneratePlanLoading] = useState<boolean>(false);
  const [totalData, setTotalData] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(true);

  const hasFetched = useRef(false);
  const [hasData, setHasData] = useState<boolean>(location.state?.hasData || false);
  const { taskId } = location.state as { hasData: boolean; taskId: string };
  console.log(hasData);

  // 获取Copilot数据
  const fetchCopilotData = async () => {
    try {
      setLoading(true);
      if (hasData) {
        getCopilotValueByTaskIdApi({
          externalUserId: EXTERNAL_USER_ID,
          reqType: 4,
          taskId
        }).then(res => {
          setTotalData(res);
        });
      }
    } catch (error) {
      console.error('获取Copilot数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  // 组件挂载时获取数据
  useEffect(() => {
    console.log('HomePage 组件挂载');
    // 防止在 StrictMode 下重复调用
    if (!hasFetched.current) {
      hasFetched.current = true;
      fetchCopilotData();
    }
  }, []);

  const { startPolling } = usePollingApi(
    // API 调用函数
    taskId =>
      getCopilotValueByTaskIdApi({
        externalUserId: EXTERNAL_USER_ID,
        reqType: 4,
        taskId: taskId || ''
      }),
    response => {
      return response?.status === 'false';
    },
    {
      interval: 1000,
      onSuccess: data => {
        console.log('轮询成功，获取到数据:', data);
        // setTotalData11(data);
        // toast.success('数据获取成功');
        setGeneratePlanLoading(false);
        setHasData(true);
        setTotalData(data);
      },
      onError: error => {
        console.error('轮询失败:', error);
        toast.error(error || '数据获取失败');
        setGeneratePlanLoading(false);
        setHasData(false);
        setTotalData(null);
      }
    }
  );

  const onGeneratePlan = async (text: string) => {
    const response = await qryCopilotValueApi({
      externalUserId: EXTERNAL_USER_ID,
      reqType: 1,
      text
    });

    setGeneratePlanLoading(true);

    startPolling(response);
  };

  const goBack = () => {
    navigate(-1);
  };

  const product = {
    name: '招商银行现金宝',
    code: '123456',
    riskLevel: '低风险',
    features: ['灵活', '稳健'],
    allocation: '20%',
    redemptionFee: '0%',
    maxDrawdown: '1.5%',
    metrics: [
      {
        label: '近1年收益率',
        value: '3.25%',
        color: '#52C41A',
        subValue: '同类平均 2.8%'
      },
      {
        label: '成立以来收益',
        value: '25.4%',
        color: '#1677FF',
        subValue: '年化 4.2%',
        subValue2: '最大回撤 -2.3%'
      }
    ]
  };

  return (
    <div className="relative mx-auto flex h-screen flex-col overflow-hidden bg-gradient-to-b from-blue-50 via-blue-50 to-purple-100">
      <Header goBack={goBack}>
        <div className="text-lg font-semibold leading-none tracking-tight">定制资产配置方案</div>
      </Header>
      <ScrollArea className="scroll-area-block h-full w-full">
        <div className="px-4">
          {/* 宏观市场环境分析 */}
          <MacroEnv />
          {/* 客户投资需求 */}
          <ClientNeeds
            onGeneratePlan={onGeneratePlan}
            generatePlanLoading={generatePlanLoading}
            totalData={totalData}
            hasData={hasData}
          />
          {totalData && (
            <div>
              {/* 资产配置方案 */}
              <AssetAllocation totalData={totalData} />
              {/* 产品配置卡片 */}
            </div>
          )}
        </div>
      </ScrollArea>
    </div>
  );
});

DiagnosisPage.displayName = 'DiagnosisPage';
export default DiagnosisPage;
